import { createRoot } from 'react-dom/client'
import HttpsRedirect from 'react-https-redirect'

import App from '@/App'
import keys from '@/config/keys'
import { isLocalEnv } from '@/config/endpoints'
import preloadImage from '@/utils/preloadImage'
import axiosReqInterceptor from '@/utils/axiosReqInterceptor'
import axiosResInterceptor from '@/utils/axiosResInterceptor'
import setAxiosDefaultHeader from '@/utils/setAxiosDefaultHeader'

// Load the logo
preloadImage(localStorage.getItem(keys.SPLASH_LOGO))

// Axios - AJAX Related
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000229 } : {} // EMMA_2
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000423 } : {} // v2demo
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000449 } : {} // 25demo25
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 1000000128 } : {} // wizardtemplate
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000391 } : {} // EMMA2025
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000409} : {} // jdjdjd
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000434 } : {} // reg_test
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000430 } : {} // cyberpunkV2
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000420 } : {} // rl-clone-1
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000422 } : {} // rl-clone-3
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000396 } : {} // wiz-20250123
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000387 } : {} // cwc-uk
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000157 } : {} // cats
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000372 } : {} // LM
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000359 } : {} // RODEO
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000411 } : {} // elizagolfday
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000436 } : {} // auctiondomain
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000435 } : {} // native-v2-event
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000442 } : {} // awf
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000443 } : {} // IG2
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000455 } : {} // signuptests
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000461 } : {} // maytestevent
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000465 } : {} // maytestevent2
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000441 } : {} // v2-header-test
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000454 } : {} // ouhasdfip
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000480 } : {} // junetest
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000484 } : {} // junetest2
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000479 } : {} // guestchecking
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000495 } : {} // july-dev-test
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000496 } : {} // us-july-event
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000549 } : {} // augustdevtest
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000498 } : {} // performancepages-1
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000560 } : {} // JTest
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000563 } : {} // iatest
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000565 } : {} // autumn
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000479 } : {} // guestchecking
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000576 } : {} // uniquetests
// const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000564 } : {} // buy_tickets
const HEADERS = isLocalEnv ? { [keys.HEADERS.EVENT_ID]: 990000584 } : {} // paymentdiscre

setAxiosDefaultHeader(true, HEADERS)
axiosReqInterceptor()
axiosResInterceptor()

const root = createRoot(document.getElementById('root'))
root.render(
	<HttpsRedirect>
		<App />
	</HttpsRedirect>,
)
